import { FileUploadModule } from 'ng2-file-upload';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { MaterialModule } from "./material-file/material.module";
import { SharedModuleModule } from "./shared-module/shared-module.module";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { RequestInterceptor } from "./services/interceptor/RequestInterceptor";
import { LoaderService } from "./services/loader.service";
import { LoadingComponent } from "./core-files/loaders/Loader";
import { ToastComponent } from "./core-files/loaders/toast-messages";
import { Network } from "@ionic-native/network/ngx";
// import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { NotificationsService } from './services/notifications.service';
import { LoginModule } from './modules/login/login.module';
import { CommonModule } from '@angular/common';

@NgModule({ declarations: [AppComponent],
    exports: [],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        BrowserModule,
        IonicModule.forRoot({
            animated: true,
            scrollAssist: false,
            scrollPadding: false,
        }),
        AppRoutingModule,
        MaterialModule,
        SharedModuleModule,
        FileUploadModule,
        LoginModule
        // NgxMaterialTimepickerModule
    ], providers: [
        StatusBar,
        SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
        LoaderService,
        LoadingComponent,
        ToastComponent,
        Network,
        NotificationsService,
        provideHttpClient(withInterceptorsFromDi())
    ],
    
})
export class AppModule {}
